import { Tooltip, TooltipTrigger } from "@artis/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter as faFilterEmpty } from "@fortawesome/pro-regular-svg-icons";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import cn from "mcn";

interface FilterToggleButtonProps {
  isActive: boolean;
  onClick?: () => void;
  className?: string;
}

export function FilterToggleButton({ isActive, onClick, className }: FilterToggleButtonProps) {
  return (
    <TooltipTrigger>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          "inline-flex items-center justify-center w-[27px] h-[27px] p-[4.5px] cursor-pointer transition-colors",
          "border border-transparent",
          [
            isActive,
            "rounded-lg text-primary hover:bg-[var(--primary-tonal)]",
            "rounded-full text-[var(--neutral-default)] hover:bg-[var(--neutral-tonal)] hover:text-[var(--neutral-on-tonal)]",
          ],
          className,
        )}
        aria-label="Filter values"
      >
        <FontAwesomeIcon icon={isActive ? faFilter : faFilterEmpty} className="w-[15.75px] h-[14.625px]" />
      </button>
      <Tooltip>Filter values</Tooltip>
    </TooltipTrigger>
  );
}
